<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import numberMixin from '../../../../mixins/numberMixin';
import ConfirmDialog from '../../../../components/TwConfirmDialog';
import salesTypeEnums from '../../../../variables/ski/pass/sales-type-enums';
import statusEnums from '../../../../variables/ski/pass/status-type-enums';
import keyCardPaymentTypeEnums from '../../../../variables/ski/pass/key-card-payment-type-enums';

export default {
  name: 'SkiPassAvailableProducts',
  data() {
    return {
      selectedArea: undefined,
      keyCardPaymentTypeMandatory: keyCardPaymentTypeEnums.MANDATORY,
    };
  },
  components: {
    ConfirmDialog,
  },
  mixins: [numberMixin],
  computed: {
    ...mapGetters({
      participants: 'booking/getParticipantsWithFullName',
      availableDates: 'booking/getAvailableDates',
      mappedAvailablePassProducts: 'skipass/getAvailableSkiPassProducts',
      availablePassProductsPersonCategoryHeaders: 'skipass/getAvailableSkiPassProductsPersonCategoryHeaders',
      defaultAreaId: 'booking/getDefaultAreaId',
      availableNumberOfDays: 'skipass/getAvailableNumberOfDays',
    }),
    ...mapState({
      participantsLoading: state => state.booking.participants.itemsLoading,
      participantsError: state => state.booking.participants.itemsError,
      selectedBookingParticipantId: state => state.skipass.search.selectedBookingParticipantId,
      selectedStartDate: state => state.skipass.search.selectedStartDate,
      selectedNumberOfDays: state => state.skipass.search.selectedNumberOfDays,
      bookingParticipants: state => state.skipass.bookingParticipants.items,
      skipass: state => state.skipass.pass.items,
      skipassLoading: state => state.skipass.pass.itemsLoading,
      skipassError: state => state.skipass.pass.itemsError,
      availablePassProducts: state => state.skipass.availablePassProducts,
      booking: state => state.booking.booking,
      user: state => state.app.auth.user,
      areas: state => state.booking.areas.items,
    }),
    canSearch() {
      return this.booking.id
        && this.booking.stays
        && this.booking.stays.length
        && this.participants
        && this.participants.length
        && this.selectedBookingParticipantId
        && this.selectedStartDate
        && this.selectedNumberOfDays
        && (this.selectedArea || this.defaultAreaId);
    },
    loading() {
      return this.participantsLoading
        || this.skipassLoading
        || this.availablePassProducts.itemsLoading
        || this.availablePassProducts.saveLoading;
    },
    errorOccurred() {
      return this.skipassError
        || this.availablePassProducts.itemsError
        || this.participantsError
        || this.availablePassProducts.saveError;
    },
    areaParticipants() {
      return this.participants.filter(participant => participant.areaId === this.getSelectedAreaId());
    },
  },
  methods: {
    ...mapActions({
      loadAvailablePassPrices: 'skipass/availablePassPricesLoad',
      loadPassByBookingId: 'skipass/passByBookingIdLoad',
      createPass: 'skipass/passCreate',
      deletePass: 'skipass/passDelete',
      setBookingParticipant: 'skipass/setBookingParticipant',
      setStartDate: 'skipass/setStartDate',
      setNumberOfDays: 'skipass/setNumberOfDays',
    }),
    createSkiPassProduct(params) {
      const priceGross = params.price.priceGross;
      const priceNet = params.price.priceNet;
      let discountGross = null;
      let discountNet = null;
      let discountBookFrom = null;
      let discountBookTo = null;
      if (params.price.discount && params.price.discount.id) {
        const discountPercentage = params.price.discount.percentage / 100;
        discountGross = this.$options.filters.roundNumber(priceGross * discountPercentage, 0);
        discountNet = this.$options.filters.roundNumber(priceNet * discountPercentage, 0);
        discountBookFrom = params.price.discount.bookFrom;
        discountBookTo = params.price.discount.bookTo;
      }
      const personCategoryAges = `(${params.price.personCategory.ageFrom}-${params.price.personCategory.ageTo} years)`;
      const skiPass = {
        bookingId: this.booking.id,
        areaId: this.getSelectedAreaId(),
        bookingParticipantId: this.selectedBookingParticipantId,
        productsSkiPassSeasonId: params.product.season.id,
        productsSkiPassPersonCategoryId: params.price.personCategory.id,
        status: statusEnums.INITIATED,
        salesType: salesTypeEnums.BOOKING,
        supplierRef: null,
        firstSkiDay: this.selectedStartDate,
        numberOfDays: params.product.days,
        price: this.$options.filters.roundNumber(priceGross, 0),
        priceNet: this.$options.filters.roundNumber(priceNet, 0),
        keyCardPrice: params.price.isKeyCardMandatory ? params.price.keyCardGross : null,
        keyCardPriceNet: params.price.isKeyCardMandatory ? params.price.keyCardNet : null,
        currencyNet: params.product.season.supplier.currency,
        supplierName: params.product.season.supplier.name,
        seasonName: params.product.season.name,
        personCategoryName: params.price.personCategory.name + personCategoryAges,
        seasonNameSupplier: params.product.season.name,
        personCategoryNameSupplier: params.price.personCategory.externalName + personCategoryAges,
        discount: discountGross,
        discountNet,
        discountBookFrom,
        discountBookTo,
      };
      this.createPass({
        bookingId: this.booking.id,
        bookingParticipantId: this.selectedBookingParticipantId,
        skiPass,
      });
    },
    searchAvailableProducts() {
      if (!this.canSearch) {
        return;
      }
      const participant = this.participants.find(
        item => item.id === this.selectedBookingParticipantId,
      );
      const areaId = this.selectedArea || this.defaultAreaId;
      this.loadAvailablePassPrices({
        areaId,
        numberOfDays: this.selectedNumberOfDays,
        participantAge: participant.age,
        skiStartDayDate: this.selectedStartDate,
        targetCurrency: this.booking.currency,
      });
    },
    doRefresh() {
      this.loadPassByBookingId(this.booking.id);
      this.searchAvailableProducts();
    },
    deleteProductDialog(skiPassId) {
      this.deletePass({ skiPassId, salesAgentUserId: this.user.id });
    },
    openConfirmDialog(type) {
      const vueComponent = this.$refs[type];
      if (vueComponent instanceof Array) {
        vueComponent[0].open();
      } else {
        vueComponent.open();
      }
    },
    onBookingParticipantChange(participantId) {
      this.setBookingParticipant(participantId);
      this.searchAvailableProducts();
    },
    onStartDateChange(startDate) {
      this.setStartDate(startDate);
      this.searchAvailableProducts();
    },
    onNumberOfDaysChange(days) {
      this.setNumberOfDays(days);
      this.searchAvailableProducts();
    },
    onAreaChange(areaId) {
      this.selectedArea = areaId;
      this.searchAvailableProducts();
    },
    getSelectedAreaId() {
      return this.selectedArea || this.defaultAreaId;
    },
  },
  mounted() {
    const arrivalDate = this.booking.stays[0].arrivalDate;
    const departureDate = this.booking.stays[0].departureDate;
    const numberOfDays = this.$moment(departureDate).diff(this.$moment(arrivalDate), 'days') + 1;
    this.setStartDate(arrivalDate);
    this.setNumberOfDays(numberOfDays);
  },
};
</script>

<template>
  <v-container v-if="booking && booking.id" class="pa-0 pt-3" grid-list-xl>
    <v-card class="pa-3 mx-auto" outlined>
      <v-layout class="pt-3 px-3">
        <v-flex class="ma-0 pa-0" sm5 xs12>
          <v-select
            @change="onBookingParticipantChange($event)"
            :value="selectedBookingParticipantId"
            :items="areaParticipants"
            :loading="participantsLoading"
            :disabled="participantsLoading || !areaParticipants.length"
            :label="$t('ski.pass.selects.booking-participant')"
            item-text="fullName"
            item-value="id"
          />
        </v-flex>
        <v-flex class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onStartDateChange($event)"
            :value="selectedStartDate"
            :items="availableDates"
            :loading="participantsLoading"
            :disabled="participantsLoading"
            :label="$t('ski.pass.selects.start-date')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
        <v-flex class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onNumberOfDaysChange($event)"
            :value="selectedNumberOfDays"
            :items="availableNumberOfDays"
            :loading="participantsLoading"
            :disabled="participantsLoading"
            :label="$t('ski.pass.selects.number-of-days')"
          />
        </v-flex>
        <v-flex v-if="areas.length > 1" class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onAreaChange($event)"
            :value="defaultAreaId"
            :items="areas"
            :label="$t('ski.pass.selects.area')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
        <v-flex class="pl-2 ma-0 pa-0" sm1 xs12>
          <v-btn
            @click="doRefresh"
            :loading="loading"
            icon
          >
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <div class="text-center pa-1">
      <v-progress-linear v-show="loading" :indeterminate="true"/>
    </div>
    <v-alert
      :value="this.errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"></span>
    </v-alert>
    <div
      v-if="!Object.keys(mappedAvailablePassProducts).length && canSearch && !loading"
      class="py-3 font-weight-bold"
    >
      {{ $t('ski.pass.no-available-pass-products') }}
    </div>
    <v-container v-if="Object.keys(mappedAvailablePassProducts).length > 0" grid-list-md xs12>
      <div class="py-3 font-weight-bold">
        <v-layout class="pb-0 mb-0 no-wrap" row>
          <v-flex class="d-flex pt-3" sm8 xs12 offset-sm3>
            <v-flex
              v-for="personCategory in availablePassProductsPersonCategoryHeaders"
              :key="personCategory.id"
              class="ma-0 pa-0 text-uppercase"
              sm4
              xs12
            >
              {{ personCategory.name }} ({{ $t('ski.pass.years-from-to', {
              from: personCategory.ageFrom,
              to: personCategory.ageTo
              }) }})
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout
          v-for="(skiPass) in mappedAvailablePassProducts"
          :key="skiPass.id"
          class="pb-0"
          row
        >
          <v-flex class="pt-3 pr-3" sm3 xs12>
            <template
              v-if="skiPass.product.season.keyCardPaymentType === keyCardPaymentTypeMandatory"
            >
              {{ $t('ski.pass.pass-incl-key-card') }}
            </template>
            <template v-else>
              {{ $t('ski.pass.pass-excl-key-card') }}
            </template>
          </v-flex>
          <v-flex class="ma-0 pa-0 d-flex" sm8 xs12>
            <v-flex
              v-for="(price) in skiPass.prices"
              :key="price.id"
              class="ma-0 pa-0"
              sm4
              xs12
            >
              <v-chip
                v-if="price.hasDiscount && price.discount"
                :title="$t('ski.pass.discount-percentage')"
                color="red"
                text-color="white"
                class="caption"
                disabled
                small
              >
                -{{ price.discount.percentage }}%
              </v-chip>
              <v-btn
                v-if="price.id && !price.bookingPassProductId"
                @click="createSkiPassProduct({ product: skiPass.product, price })"
                :disabled="loading"
                :loading="loading"
                :title="$t('ski.pass.add-product')"
                outline
              >
                <template v-if="price.hasDiscount">
                  {{ price.totalGrossAfterDiscount }}
                  <template v-if="price.isKeyCardMandatory">
                    + {{ price.keyCardGross }}
                  </template>
                  {{ booking.currency }}
                  <span class="text-line-through pl-2 red--text caption">
                    {{ price.priceGross }}
                    {{ booking.currency }}
                  </span>
                </template>
                <template v-else>
                  {{ price.priceGross }}
                  <template v-if="price.isKeyCardMandatory">
                    + {{ price.keyCardGross }}
                  </template>
                  {{ booking.currency }}
                </template>
              </v-btn>
              <template v-if="price.id && price.bookingPassProductId">
                <v-btn
                  @click="openConfirmDialog('confirm-delete-dialog-' + price.bookingPassProductId)"
                  :disabled="loading"
                  :loading="loading"
                  :title="$t('ski.pass.remove-product')"
                  color="success"
                >
                  {{ price.totalGrossAfterDiscount }}
                  <template v-if="price.isKeyCardMandatory">
                    + {{ price.keyCardGross }}
                  </template>
                  {{ booking.currency }}
                  <v-icon right>cancel</v-icon>
                </v-btn>
                <confirm-dialog
                  @confirm="deleteProductDialog(price.bookingPassProductId)"
                  :title="$t('ski.pass.confirm-title')"
                  :description="$t('ski.pass.deleteAreYouSure')"
                  :ref="'confirm-delete-dialog-' + price.bookingPassProductId"
                >
                </confirm-dialog>
              </template>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
    </v-container>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/pass/SkiPassAvailableProducts.vue